import React from "react"
import PropTypes from "prop-types"
import { Select } from "antd"


const FilterSelect = ({ value, onChange, options, placeholder, filterMultiple }) => {
  const style = {
    minWidth: 200
  }

  const filterOption = (input, option) =>
    (option?.label ?? '')
      .toLowerCase()
      .includes(input.toLowerCase())

  const selectProps = {
    variant: "filled",
    showSearch: true,
    allowClear: true,
    optionFilterProp: "children",
    value,
    style,
    options,
    onChange,
    placeholder,
    filterOption,
  }

  if (filterMultiple) {
    selectProps.mode = "multiple"
  }

  return (
    <Select {...selectProps} />
  )
}

FilterSelect.propTypes = {
  value: PropTypes.oneOfType([ PropTypes.string, PropTypes.arrayOf(PropTypes.string) ]),
  filterMultiple: PropTypes.bool,
}

FilterSelect.defaultProps = {
  value: undefined,
  filterMultiple: false,
}

export default FilterSelect
